export enum ReferralProduct {
  Chargebacks = "chargebacks",
}
